var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicaVacantes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.437,
    height: 100.437,
    viewBox: "0 0 100.437 100.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a4c2f7;}.b{fill:url(#a);}.c{fill:#7fabfa;}.d{fill:#d4e1f4;}.e{fill:#f1eaf4;}.f{fill:#efd2ff;}.g{fill:#fff;}.h{fill:#264ecc;}.i{fill:#7821a0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4.443,
    y1: -4.646,
    x2: 4.445,
    y2: -4.643,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce3ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#dae2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#ebeaf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#f6eff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fdf2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8f0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e7e8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dce3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d5e0f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#fff3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#d3dff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3dff2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(770.165 -739.818)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-768.492 741.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-670.144,746.1V816.4h-97.089V746.1a3.358,3.358,0,0,1,3.348-3.348h90.393A3.358,3.358,0,0,1-670.144,746.1Z",
    transform: "translate(767.233 -742.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-675.166,746.1V816.4h-92.067V746.1a3.358,3.358,0,0,1,3.348-3.348h85.371A3.358,3.358,0,0,1-675.166,746.1Z",
    transform: "translate(767.233 -742.751)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20.087,
    height: 18.414,
    transform: "translate(38.501 73.654)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-670.144,865.923v3.348a3.358,3.358,0,0,1-3.348,3.348h-90.393a3.358,3.358,0,0,1-3.348-3.348v-3.348Z",
    transform: "translate(767.233 -865.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-675.957,903.388v3.164h-50.218v-3.164a5.2,5.2,0,0,1,1.523-3.683,5.2,5.2,0,0,1,3.683-1.523h39.807a5.2,5.2,0,0,1,3.683,1.523A5.2,5.2,0,0,1-675.957,903.388Z",
    transform: "translate(749.611 -879.769)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-688.492,871.788V890.2h-20.087v-3.348h5.022V875.136h-5.022v-3.348Z",
    transform: "translate(742.058 -798.134)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 70.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-675.166,865.923v3.348a3.358,3.358,0,0,1-3.348,3.348h-85.371a3.358,3.358,0,0,1-3.348-3.348v-3.348Z",
    transform: "translate(767.233 -865.923)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-680.978,903.388v3.164h-45.2v-3.164a5.2,5.2,0,0,1,1.523-3.683,5.2,5.2,0,0,1,3.683-1.523h34.785a5.2,5.2,0,0,1,3.683,1.523A5.2,5.2,0,0,1-680.978,903.388Z",
    transform: "translate(749.611 -879.769)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 12.555,
    cy: 12.555,
    r: 12.555,
    transform: "translate(6.696 6.696)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.185,
    cy: 4.185,
    r: 4.185,
    transform: "translate(15.066 13.391)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.696 21.761)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-732.054,786.734v2.712a12.39,12.39,0,0,1-11.717,0v-2.712a5.865,5.865,0,0,1,5.859-5.859A5.886,5.886,0,0,1-732.054,786.734Z",
    transform: "translate(750.467 -780.875)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 12.555,
    cy: 12.555,
    r: 12.555,
    transform: "translate(0 16.74)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 4.185,
    cy: 4.185,
    r: 4.185,
    transform: "translate(15.066 45.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-732.054,842.455v2.712a12.39,12.39,0,0,1-11.717,0v-2.712a5.865,5.865,0,0,1,5.859-5.859A5.887,5.887,0,0,1-732.054,842.455Z",
    transform: "translate(757.163 -783.03)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-763.885,819.753h5.022a3.358,3.358,0,0,1-3.348-3.348V746.1a3.358,3.358,0,0,1,3.348-3.348h-5.022a3.358,3.358,0,0,0-3.348,3.348V816.4A3.358,3.358,0,0,0-763.885,819.753Z",
    transform: "translate(767.233 -742.751)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 5.022,
    height: 11.718,
    transform: "translate(38.501 77.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-720.969,898.182a5.2,5.2,0,0,0-3.683,1.523,5.2,5.2,0,0,0-1.523,3.683v3.163h5.022v-3.163a5.2,5.2,0,0,1,1.523-3.683,5.2,5.2,0,0,1,3.683-1.523Z",
    transform: "translate(749.611 -809.463)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-770.165 739.818)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-766.817,748.616v70.306h-3.348V748.616Z",
    transform: "translate(770.165 -743.594)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-768.483,772.492a1.762,1.762,0,0,0,1.189-.486,1.7,1.7,0,0,0,0-2.377l-.251-.2a1.292,1.292,0,0,0-.3-.151,1.06,1.06,0,0,0-.3-.1,2.439,2.439,0,0,0-.335-.034,1.759,1.759,0,0,0-1.188.486,1.727,1.727,0,0,0,0,2.377,1.727,1.727,0,0,0,.552.352A1.664,1.664,0,0,0-768.483,772.492Z",
    transform: "translate(770.156 -752.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-674.75,739.818h-90.393a5.027,5.027,0,0,0-5.022,5.022v6.7a1.674,1.674,0,0,0,1.674,1.674,1.674,1.674,0,0,0,1.674-1.674v-6.7a1.676,1.676,0,0,1,1.674-1.674h90.394a1.676,1.676,0,0,1,1.674,1.674v65.284h-93.741v-45.2a1.674,1.674,0,0,0-1.674-1.674,1.674,1.674,0,0,0-1.674,1.674v50.218a5.027,5.027,0,0,0,5.022,5.022h33.479v8.37h-8.193a6.88,6.88,0,0,0-6.872,6.872v3.171a1.674,1.674,0,0,0,1.674,1.674h50.219a1.674,1.674,0,0,0,1.674-1.674V835.41a6.88,6.88,0,0,0-6.872-6.872h-8.194v-8.37h33.479a5.027,5.027,0,0,0,5.022-5.022V744.84A5.027,5.027,0,0,0-674.75,739.818Zm-21.761,95.592v1.5h-46.871v-1.5a3.529,3.529,0,0,1,3.525-3.525h39.822A3.528,3.528,0,0,1-696.511,835.41Zm-15.065-6.872h-16.739v-8.37h16.739Zm36.827-11.718h-90.393a1.676,1.676,0,0,1-1.674-1.674v-1.674h93.742v1.674A1.676,1.676,0,0,1-674.75,816.82Z",
    transform: "translate(770.165 -739.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-744.206,780.006a14.229,14.229,0,0,0,14.229-14.229,14.229,14.229,0,0,0-14.229-14.228,14.228,14.228,0,0,0-14.228,14.228A14.244,14.244,0,0,0-744.206,780.006Zm-4.185-4.187v-1.671a4.19,4.19,0,0,1,4.185-4.185,4.213,4.213,0,0,1,4.184,4.185v1.671A10.85,10.85,0,0,1-748.391,775.818Zm1.674-11.715a2.511,2.511,0,0,1,2.511-2.511,2.511,2.511,0,0,1,2.511,2.511,2.511,2.511,0,0,1-2.511,2.511A2.514,2.514,0,0,1-746.717,764.1Zm2.511-9.207a10.866,10.866,0,0,1,10.107,6.839,10.867,10.867,0,0,1-2.622,11.919,7.379,7.379,0,0,0-2.157-4.818,7.531,7.531,0,0,0-.994-.827,5.859,5.859,0,0,0-.256-8.15,5.859,5.859,0,0,0-8.154,0,5.858,5.858,0,0,0-.26,8.149,7.507,7.507,0,0,0-3.147,5.649,10.868,10.868,0,0,1-2.624-11.919A10.867,10.867,0,0,1-744.206,754.9Z",
    transform: "translate(765.13 -744.853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-744.206,835.727A14.229,14.229,0,0,0-729.977,821.5a14.229,14.229,0,0,0-14.229-14.228A14.229,14.229,0,0,0-758.435,821.5,14.245,14.245,0,0,0-744.206,835.727Zm-4.185-4.187v-1.671a4.19,4.19,0,0,1,4.185-4.185,4.212,4.212,0,0,1,4.184,4.185v1.671A10.85,10.85,0,0,1-748.391,831.54Zm1.674-11.715a2.511,2.511,0,0,1,2.511-2.511,2.511,2.511,0,0,1,2.511,2.511,2.511,2.511,0,0,1-2.511,2.511A2.514,2.514,0,0,1-746.717,819.825Zm2.511-9.207a10.864,10.864,0,0,1,10.107,6.839,10.866,10.866,0,0,1-2.622,11.918,7.377,7.377,0,0,0-2.157-4.818,7.527,7.527,0,0,0-.994-.827,5.859,5.859,0,0,0-.256-8.15,5.859,5.859,0,0,0-8.154,0,5.859,5.859,0,0,0-.26,8.15,7.506,7.506,0,0,0-3.147,5.648,10.867,10.867,0,0,1-2.624-11.919A10.865,10.865,0,0,1-744.206,810.618Z",
    transform: "translate(765.13 -768.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,822.348h6.7a1.674,1.674,0,0,0,1.674-1.674A1.674,1.674,0,0,0-694.344,819h-6.7a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,822.348Z",
    transform: "translate(741.215 -773.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,834.079H-684.3a1.674,1.674,0,0,0,1.674-1.674,1.674,1.674,0,0,0-1.674-1.674H-701.04a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,834.079Z",
    transform: "translate(741.215 -778.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-631.525,830.731h-28.458a1.673,1.673,0,0,0-1.674,1.674,1.674,1.674,0,0,0,1.674,1.674h28.458a1.673,1.673,0,0,0,1.674-1.674A1.674,1.674,0,0,0-631.525,830.731Z",
    transform: "translate(723.592 -778.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,845.81h33.479a1.674,1.674,0,0,0,1.674-1.674,1.674,1.674,0,0,0-1.674-1.674H-701.04a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,845.81Z",
    transform: "translate(741.215 -783.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-618.938,842.462h-11.718a1.674,1.674,0,0,0-1.674,1.674,1.674,1.674,0,0,0,1.674,1.674h11.718a1.674,1.674,0,0,0,1.674-1.674A1.674,1.674,0,0,0-618.938,842.462Z",
    transform: "translate(711.005 -783.873)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,760.762h6.7a1.674,1.674,0,0,0,1.674-1.674,1.674,1.674,0,0,0-1.674-1.674h-6.7a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,760.762Z",
    transform: "translate(741.215 -747.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,772.493H-684.3a1.674,1.674,0,0,0,1.674-1.674,1.674,1.674,0,0,0-1.674-1.674H-701.04a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,772.493Z",
    transform: "translate(741.215 -752.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-631.525,769.145h-28.458a1.674,1.674,0,0,0-1.674,1.674,1.674,1.674,0,0,0,1.674,1.674h28.458a1.674,1.674,0,0,0,1.674-1.674A1.674,1.674,0,0,0-631.525,769.145Z",
    transform: "translate(723.592 -752.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-701.04,784.223h33.479a1.674,1.674,0,0,0,1.674-1.674,1.674,1.674,0,0,0-1.674-1.674H-701.04a1.674,1.674,0,0,0-1.674,1.674A1.674,1.674,0,0,0-701.04,784.223Z",
    transform: "translate(741.215 -757.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-618.938,780.875h-11.718a1.674,1.674,0,0,0-1.674,1.674,1.674,1.674,0,0,0,1.674,1.674h11.718a1.674,1.674,0,0,0,1.674-1.674A1.674,1.674,0,0,0-618.938,780.875Z",
    transform: "translate(711.005 -757.44)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicaVacantes);
export default __webpack_public_path__ + "static/media/publica_vacantes.4cc6fddc9baa97da16e8840c58728b43.svg";
export { ForwardRef as ReactComponent };